import {StorageObjectDTO} from '../models/dto/StorageObjectDTO';
import {UploadFileDTO} from '../models/dto/UploadFileDTO';
import {CreateFolderDTO} from '../models/dto/CreateFolderDTO';
import {EditFileDTO} from '../models/dto/EditFileDTO';
import {EditFolderDTO} from '../models/dto/EditFolderDTO';
import {SearchFilterPredefined} from '../models/SearchFilterPredefined';
import {StatusType} from '../models/StatusType';
import {LayoutViewType} from '../models/LayoutViewType';
import {SortType} from '../models/SortType';
import {SearchResultDTO} from '../models/dto/SearchResultDTO';
import {DynamicConfig} from '../models/DynamicConfig';

export const getEmptyDynamicConfig = (): DynamicConfig => {
    return {} as DynamicConfig;
};

export const getEmptySearchResultDTO = (): SearchResultDTO => {
    return {} as SearchResultDTO;
};

export const getEmptyStorageObjectDTO = (): StorageObjectDTO => {
    return {} as StorageObjectDTO;
};

export const getEmptyCreateFolderDTO = (): CreateFolderDTO => {
    return {} as CreateFolderDTO;
};

export const getEmptyEditFolderDTO = (): EditFolderDTO => {
    return {} as EditFolderDTO;
};

export const getEmptyEditFileDTO = (): EditFileDTO => {
    return {} as EditFileDTO;
};

export const getEmptyUploadFileDTO = (): UploadFileDTO => {
    return {} as UploadFileDTO;
};

export const getCreateFolderDTO = (storageObjectDTO: StorageObjectDTO): CreateFolderDTO => {
    let createFolderDTO = storageObjectDTO as CreateFolderDTO;

    return createFolderDTO;
};

export const getEditFolderDTO = (storageObjectDTO: StorageObjectDTO): EditFolderDTO => {
    let editFolderDTO = storageObjectDTO as EditFolderDTO;

    return editFolderDTO;
};

export const getEditFileDTO = (storageObjectDTO: StorageObjectDTO, thumbnail: File | null): EditFileDTO => {
    let editFileDTO = storageObjectDTO as EditFileDTO;
    editFileDTO.thumbnail = thumbnail;

    return editFileDTO;
};

export const getUploadFileDTO = (storageObjectDTO: StorageObjectDTO, thumbnail: File | null, executeFileUpload: boolean, file: File | null): UploadFileDTO => {
    let uploadFileDTO = storageObjectDTO as UploadFileDTO;
    uploadFileDTO.thumbnail = thumbnail;
    uploadFileDTO.executeFileUpload = executeFileUpload;
    uploadFileDTO.file = file;

    return uploadFileDTO;
};

export const getEmptySearchFilterPredefined = (): SearchFilterPredefined => {
    let searchFilterPredefined = {} as SearchFilterPredefined;
    searchFilterPredefined.searchParam = '';
    searchFilterPredefined.objectType = '';
    searchFilterPredefined.fileTypes = [];

    return searchFilterPredefined;
};

export const isFileDownloadable = (status: StatusType): boolean => {
    return ((status !== StatusType.UNRELEASED) && (status !== StatusType.INFECTED)) as boolean;
};

export const getLayoutTypeByKey = (key: string): LayoutViewType => {
    return LayoutViewType[key.toUpperCase() as keyof typeof LayoutViewType];
};

export const getSortTypeByKey = (key: string): SortType => {
    return SortType[key.toUpperCase() as keyof typeof SortType];
};
